/* Funcao que transforma o tipo modelo em uma rota */
export default function(tipModelo) {
    const map = {
      1: 1,
      2: 2,
      3: 4,
      4: 8,
      5: 1
    };
    return map[tipModelo];
  }